import { render } from "./ZoneElectionReport.vue?vue&type=template&id=8a8be57a&scoped=true"
import script from "./ZoneElectionReport.vue?vue&type=script&lang=js"
export * from "./ZoneElectionReport.vue?vue&type=script&lang=js"

import "./ZoneElectionReport.vue?vue&type=style&index=0&id=8a8be57a&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a8be57a"]])

export default __exports__